<template>
  <div>
    <div class="searchBox">
      <div class="searchLeft">
        <el-input
          size="medium"
          v-model="searchForm.orderId"
          type="text"
          placeholder="请输入订单ID"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-input
          size="medium"
          v-model="searchForm.userId"
          type="text" @input="searchForm.userId = String(searchForm.userId).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"
          placeholder="请输入用户ID"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-input
          size="medium"
          v-model="searchForm.phone"
          type="text" @input="searchForm.phone = String(searchForm.phone).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"
          placeholder="请输入手机号"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-input
          size="medium"
          v-model="searchForm.email"
          placeholder="请输入邮箱"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
      </div>
      <div class="searchRight">
        <!-- <el-button size="medium" type="warning" @click="getData"><i class="el-icon-setting" style="margin-right:5px;"></i>提现参数设置</el-button> -->
      </div>
    </div>
    <el-table
      border
      :data="tableData"
      height="73vh"
      style="width: 100%">
      <el-table-column
        prop="createTime"
        width="160px"
        label="录单时间">
      </el-table-column>
      <el-table-column
        prop="orderId"
        width="140px"
        label="订单ID">
      </el-table-column>
      <el-table-column
        width="70px"
        prop="userId"
        label="用户ID">
      </el-table-column>
      <el-table-column
        width="120px"
        prop="phone"
        label="手机">
      </el-table-column>
      <el-table-column
        prop="email"
        width="180px"
        label="邮箱">
      </el-table-column>
      <el-table-column
        width="80px"
        prop="proId"
        label="产品ID">
      </el-table-column>
      <el-table-column
        prop="proName"
        width="100"
        label="产品名称">
      </el-table-column>
      <el-table-column
        width="110"
        prop="totalPower"
        label="订单算力数">
      </el-table-column>
      <el-table-column
        width="140"
        label="订单总额">
        <template slot-scope="scope">
          <div>{{scope.row.moneyUsdt?scope.row.moneyUsdt:0}} USDT</div>
          <div>{{scope.row.moneyCny?scope.row.moneyCny:0}} RMB</div>
          <div>{{scope.row.moneyFil?scope.row.moneyFil:0}} FIL</div>
        </template>
      </el-table-column>
      <el-table-column
        width="80px"
        prop="rid"
        label="推荐人">
      </el-table-column>
      <el-table-column
        width="90px"
        prop="trus"
        label="托管费(%)">
      </el-table-column>
      <el-table-column
        width="80px"
        prop="channelName"
        label="归属渠道">
      </el-table-column>
      <el-table-column
        prop="earnings"
        width="130px"
        label="挖矿开始时间">
      </el-table-column>
      <el-table-column
        fixed="right"
        width="200px"
        label="操作">
        <template slot-scope="scope">
          <div v-if="scope.row.status==0">
            <el-button size="mini" type="primary" @click="changeStust(scope.row,1)"><i class="el-icon-circle-check" style="margin-right:3px;" ></i>通过</el-button>
            <el-button size="mini" type="primary" @click="refuse(scope.row)"><i class="el-icon-circle-close" style="margin-right:3px;" ></i>拒绝</el-button>
          </div>
          <span v-if="scope.row.status==1" style="color:#22bd18;font-weight:bold">通过</span>
          <span v-if="scope.row.status==2" style="color:red;font-weight:bold">拒绝</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox" v-if="totalNum > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchForm.page"
          :page-sizes="[20, 30, 40]"
          :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        >
        </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:20,
        orderId: '',
        userId:'',
        phone: '',
        email:'',
        status: ''
      },
      tableData: [],
      nodeData: null,
      radio: '',
      dataArr: [],
      tradeData: {},
      orderId: '',
      orderData: {},
      num: '',
      productId: ''
    };
  },
  created() {
    this.getTableList()
    
  },
  methods: {
    changeStust(row,type) {
      let txt
      if(type==1) {
        txt='此操作将通过该条人工录单, 是否继续?'
        this.$confirm(txt, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res = await this.$http.personStatus({id:row.id,state:type})
          if (res) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            this.getTableList()
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
      }
    },
    refuse(row) {
      this.$prompt('请输入拒绝原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async({ value }) => {
        console.log(value)
        let res = await this.$http.personStatus({id:row.id,state:2,rejectReason:value})
        if (res) {
          this.$message({
            type: 'success',
            message: '操作成功'
          });
          this.getTableList()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });       
      });
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.checkList({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
}
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
.txt_2{
  margin-bottom: 10px;
}
.txt_3{
  display: inline-block;
  width: 160px;
}
.txt_3:first-child{
  margin-right: 20px;
}
.sam_box{
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  margin-bottom: 20px;
}
.sam_box div{
  width: 210px;
  margin-right: 60px;
}
.sam_box div:nth-child(3n){
  margin-right: 0;
}
</style>
<style>
.nodeModules .el-dialog__body{
  padding:0  20px  20px;
}
.nodeModules .el-radio{
  width: 100%;
  margin-bottom: 20px;
}
</style>
